import { CmsObjectWithDefault } from '@components/Cms/types';

export type EmailSignupFormContainerCmsKey =
    | 'emailValidationEmpty'
    | 'emailValidationFormat'
    | 'passwordValidationEmpty'
    | 'confirmPasswordValidationMatch'
    | 'confirmPasswordValidationLength'
    | 'emailAlreadyExistsQuestion'
    | 'emailAlreadyExistsQuestionPartnerCenter'
    | 'emailAlreadyExistsSignin'
    | 'emailAlreadyExistsResetPassword'
    | 'forgotPassword'
    | 'pleaseTryAgain'
    | 'technicalDifficulty'
    | 'congratulationsYourAccountHasBeenCreated'
    | 'firstNameValidationFormat'
    | 'lastNameValidationFormat'
    | 'serverError'
    | 'partnerCenterAgreeToTermsError';
export const EmailSignupFormContainerCmsWithDefault: CmsObjectWithDefault<EmailSignupFormContainerCmsKey> = {
    firstNameValidationFormat: {
        cmsId: 76301,
        defaultTranslation: 'Please enter a valid first name (English only)',
    },
    lastNameValidationFormat: {
        cmsId: 76302,
        defaultTranslation: 'Please enter a valid last name (English only)',
    },
    emailValidationEmpty: {
        cmsId: 76303,
        defaultTranslation: 'Please enter a valid email address.',
    },
    emailValidationFormat: {
        cmsId: 76303,
        defaultTranslation: 'Please enter a valid email address.',
    },
    passwordValidationEmpty: {
        cmsId: 76304,
        defaultTranslation: 'Your password is empty, please fill in the password',
    },
    confirmPasswordValidationMatch: {
        cmsId: 76305,
        defaultTranslation: 'Passwords do not match. Please re-enter passwords.',
    },
    confirmPasswordValidationLength: {
        cmsId: 76577,
        defaultTranslation: 'Please enter a valid password, Must be a minimum 8 Characters',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    emailAlreadyExistsQuestion: {
        cmsId: 76306,
        defaultTranslation:
            'An account already exists for this email address. Would you like to send an email to reset your password',
    },
    emailAlreadyExistsQuestionPartnerCenter: {
        cmsId: 286255,
        defaultTranslation:
            "Email Address Already Registered. If you have an existing account, please {0} with this account. If you've forgotten your password, you can {1} to regain access",
    },
    emailAlreadyExistsSignin: {
        cmsId: 286260,
        defaultTranslation: 'sign in',
    },
    emailAlreadyExistsResetPassword: {
        cmsId: 286261,
        defaultTranslation: 'reset password',
    },
    forgotPassword: {
        cmsId: 59489,
        defaultTranslation: 'Forgot password',
    },
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    congratulationsYourAccountHasBeenCreated: {
        cmsId: 76309,
        defaultTranslation: 'Congratulations your account has been created and you have been logged in',
    },
    serverError: {
        cmsId: 82924,
        defaultTranslation: 'Server error',
    },
    partnerCenterAgreeToTermsError: {
        cmsId: 66550,
        defaultTranslation: 'Please acknowledge that you understand and consent to our affiliate agreement.',
    },
};
